import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import remarkImages from 'remark-images';
import rehypeUnwrapImages from 'rehype-unwrap-images';
import MLink from '@mui/material/Link';
import Divider from '@mui/material/Divider';
import { makeStyles } from 'tss-react/mui';

const youtubeRegex = /http(?:s?):\/\/(?:www\.)?youtu(?:be\.com\/watch\?v=|\.be\/)([\w\-\_]*)(&(amp;)?‌​[\w\?‌​=]*)?/;

const useStyles = makeStyles()((theme) => ({
  root: {
    overflowWrap: 'break-word',
    wordBreak: 'break-word',
  },
  youtubeContainer: {
    width: 450,
    maxWidth: '100%',
    margin: theme.spacing(2, 0)
  },
  youtubeEmbedWrapper: {
    position: 'relative',
    paddingBottom: '56.25%',
    paddingTop: 30,
    height: 0,
    overflow: 'hidden',
    '& > iframe, & > object, & > embed': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%'
    }
  },
  divider: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  },
  image: {
    maxWidth: '100%',
    maxHeight: 500,
  },
}));

const Markdown = (props) => {
  const { classes } = useStyles();

  return (
    <div className={classes.root}>
      <ReactMarkdown
        components={{
          // eslint-disable-next-line @typescript-eslint/no-unused-vars -- destructure node to exclude from DOM props
          a: function LinkRenderer({ node, ...props }) {
            const youtubeMatch = props.href ? props.href.match(youtubeRegex) : null;
            if (youtubeMatch) {
              return (
                <div className={classes.youtubeContainer}>
                  <div className={classes.youtubeEmbedWrapper}>
                    <iframe
                      src={`https://www.youtube.com/embed/${youtubeMatch[1]}`}
                      frameBorder="0"
                      allowFullScreen
                    />
                  </div>
                </div>
              );
            }
            return <MLink {...props} rel="noopener noreferrer" />;
          },
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          hr: function ThematicBreakRenderer({ node, ...props }) {
            return <Divider {...props} variant="middle" className={classes.divider} />;
          },
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          img: function ImageRenderer({ node, ...props }) {
            // eslint-disable-next-line @next/next/no-img-element
            return <img alt="" {...props} className={classes.image} />;
          },
        }}
        remarkPlugins={[
          remarkGfm,
          remarkImages,
        ]}
        rehypePlugins={[
          rehypeUnwrapImages,
        ]}
        unwrapDisallowed
        {...props}
      />
    </div>
  );
};

export default Markdown;
